export const imageMimeTypes: Record<string, string | undefined> = {
  'image/png': 'PNG',
  'image/jpeg': 'JPEG',
  'image/webp': 'WebP',
};

export type ChartImageExportMimeType = 'image/png' | 'image/jpeg' | 'image/webp';
